import { render, staticRenderFns } from "./Txt.vue?vue&type=template&id=1fe70a52&"
import script from "./Txt.vue?vue&type=script&lang=js&"
export * from "./Txt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports